import { isNil } from 'lodash';
import React from 'react';

import './ZeroStateWithBankStatus.scss';

import ContactNote from '../ContactNote/ContactNote';
import config from '../../../config/config';
import { BANK_STATUS } from '../../../settings/settings';
import If from '../../Shared/If/If';
import { getLastFour } from '../../../utils/banking/bank-utils';
import { calculateAndFormatUnixDates } from '../../../utils/dates/date-utility';

const ZeroStateWithBankStatus = ({ className, eligibleBanks, date }) => (
  <div className={`zero-state-bank-status-container ${className}`}>
    <div className="zero-state-bank-status-heading">
      {eligibleBanks.length === 1
        ? 'Address and Bank Changes in Progress'
        : 'Awaiting New Address and Bank Verification'}
    </div>
    <div className="zero-state-bank-status-description">
      {eligibleBanks.length === 1
        ? 'Changes to both your mailing address and bank information are in progress and, as a result, you may not submit an online redemption until the changes are completed.'
        : 'Both your mailing address and bank information have been recently updated. '}{' '}
      <ContactNote className="zero-state-bank-status-contact-note" />
    </div>
    <div className="zero-state-bank-status-list">
      <div className="zero-state-bank-status-space">
        &#8226;{' '}
        {eligibleBanks.length === 1
          ? 'You may submit an online redemption and have proceeds delivered by check beginning on '
          : 'Your mailing address will be available for redemptions on '}
        <span>{date}.</span>
      </div>
      {eligibleBanks.map((bank) => {
        return (
          <div>
            <If test={bank.bankStatus === BANK_STATUS.PREPARING_MICRO_DEPOSITS}>
              <div className="zero-state-bank-status-space">
                &#8226;You may submit an online redemption and have proceeds
                delivered to your bank account ending in{' '}
                <span className="blocked_data">{`${getLastFour(
                  bank.accountNumber
                )} `}</span>
                beginning on the <span> sixth day </span> after you{' '}
                <a
                  className="text-nowrap college-branded-link"
                  href={`${config.url}/usis/my-accounts/profile/linked-bank-accounts`}
                >
                  verify microdeposits
                </a>
                from your Bank Preferences page.
              </div>
            </If>
            <If
              test={
                bank.bankStatus === BANK_STATUS.VERIFY_MICRO_DEPOSITS &&
                eligibleBanks.length === 1
              }
            >
              <div className="zero-state-bank-status-space">
                &#8226;You may submit an online redemption and have proceeds
                delivered to your bank account ending in{' '}
                <span className="blocked_data">{`${getLastFour(
                  bank.accountNumber
                )} `}</span>
                beginning on the <span> sixth day </span> after you{' '}
                <a
                  className="text-nowrap college-branded-link"
                  href={`${config.url}/usis/my-accounts/profile/linked-bank-accounts`}
                >
                  verify microdeposits
                </a>
                from your Bank Preferences page.
              </div>
            </If>
            <If
              test={
                bank.bankStatus === BANK_STATUS.VERIFY_MICRO_DEPOSITS &&
                eligibleBanks.length !== 1
              }
            >
              <div className="zero-state-bank-status-space">
                &#8226;You may submit an online redemption and have proceeds
                delivered to your bank account ending in{' '}
                <span className="blocked_data">{`${getLastFour(
                  bank.accountNumber
                )} `}</span>
                beginning on the <span> sixth day </span> after you{' '}
                <a
                  className="text-nowrap college-branded-link"
                  href={`${config.url}/usis/my-accounts/profile/linked-bank-accounts`}
                >
                  verify microdeposits
                </a>
                from your Bank Preferences page.
              </div>
            </If>
            <If
              test={
                bank.bankStatus === BANK_STATUS.PROCESSING &&
                eligibleBanks.length === 1
              }
            >
              <div className="zero-state-bank-status-space">
                &#8226; You may submit an online redemption and have proceeds
                delivered to your bank account ending in{' '}
                <span className="blocked_data">{`${getLastFour(
                  bank.accountNumber
                )} `}</span>
                beginning on{' '}
                <span>
                  {' '}
                  {!isNil(bank.availbeForRedemtionDate) &&
                    calculateAndFormatUnixDates(
                      bank.availbeForRedemtionDate,
                      'MM/DD/YY'
                    )}
                  .{' '}
                </span>
              </div>
            </If>
            <If
              test={
                bank.bankStatus === BANK_STATUS.PROCESSING &&
                eligibleBanks.length !== 1
              }
            >
              <div className="zero-state-bank-status-space">
                &#8226; Your bank account ending in{' '}
                <span className="blocked_data">{`${getLastFour(
                  bank.accountNumber
                )} `}</span>
                will be available for redemptions on{' '}
                <span>
                  {' '}
                  {!isNil(bank.availbeForRedemtionDate) &&
                    calculateAndFormatUnixDates(
                      bank.availbeForRedemtionDate,
                      'MM/DD/YY'
                    )}
                  .{' '}
                </span>
              </div>
            </If>
          </div>
        );
      })}
    </div>
  </div>
);

export default ZeroStateWithBankStatus;
